import { render, staticRenderFns } from "./SectionNextPage.vue?vue&type=template&id=2db60237&"
import script from "./SectionNextPage.vue?vue&type=script&lang=js&"
export * from "./SectionNextPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports